module.exports = __webpack_public_path__ + "static/media/logo_FC_green_horizontal.6300e257.png";